import { useQuery } from "react-query";

import useAuth from "hooks/useAuth";
import { useFilters } from "hooks/useFilters";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DashboardResponseV3,
  getDashboardLeadsData,
  getDashboardLeadsDataV3,
} from "services/dashboardService";

export const DASHBOARD_KEY = "dashboard";

const UNO_INTERNET_PROVIDER_ID = "66227aa39a54f0f265466127";

type TAB = "leads" | "sales";

export const useViewmodel = () => {
  const { user, selectedProvider, selectedSeller } = useAuth();
  const { selectedDate } = useFilters();
  const { t } = useTranslation();

  const [tab, setTab] = useState<TAB>("leads");

  const range = `${selectedDate?.initDate.toDateString()}-${selectedDate?.endDate.toDateString()}`;

  const isV3 = selectedProvider.id === UNO_INTERNET_PROVIDER_ID;

  const dashboardData = useQuery(
    [DASHBOARD_KEY, isV3 ? "v3" : "v2", user?._id, range, selectedProvider.id, selectedSeller],
    async () => {
      if (isV3) {
        return getDashboardLeadsDataV3(
          selectedDate!.initDate,
          selectedDate!.endDate,
          selectedSeller
        );
      }
      return getDashboardLeadsData(
        selectedDate!.initDate,
        selectedDate!.endDate,
        selectedSeller
      );
    },
    { enabled: selectedProvider.id !== "admin" }
  );
  dashboardData.isLoading =
    dashboardData.isLoading || (dashboardData.isFetching && !dashboardData.data) || dashboardData.isRefetching;

  const refetch = () => {
    dashboardData.refetch();
  };

  return {
    dashboardData: dashboardData.data,
    dashboardVersion: isV3 ? ("v3" as const) : ("v2" as const),
    isLoading: dashboardData.isLoading,
    hasError: dashboardData.isError,
    refetch,
    hasProvider: selectedProvider.id !== "admin",
    selectedProvider,
    tab,
    setTab,
    t,
  };
};
